import { Component, inject } from '@angular/core';
import { BannerAction, BannerService } from '@Services/banner.service';
import { AsyncPipe, NgClass } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'banner-component',
    templateUrl: './banner.component.html',
    styleUrls: ['./banner.component.scss'],
    imports: [AsyncPipe, NgClass, MatIconModule, MatButtonModule]
})
export class BannerComponent {
    private readonly bannerService = inject(BannerService);
    banner$ = this.bannerService.banner$;

    dismiss(): void {
        this.bannerService.dismissBanner();
    }

    onAction(action: BannerAction): void {
        if (action.route) {
            this.bannerService.navigate(action.route);
        }
    }
}
